export const getBaseRoute = 'https://my.icareus.com/api';
